import { BuildedNode } from './BuildedNode';
import { OutputLink } from './OutputLink';

export class BuildContext {
  public readonly objects: BuildedNode[] = [];
  public readonly links: OutputLink[] = [];
}
